import { SiteData } from "../Data/SiteData";
import SiteStyleCollectionMenu from "./SiteStyleCollectionMenu";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";



export default function ButtonsSettingsMenu({siteData,saveFunc}:{saveFunc:Function,siteData:SiteData}){

    return <SiteStyleCollectionMenu 
      title="Buttons"
      saveFunc={saveFunc}
      siteData={siteData}
      collectionList={[siteData.siteStyling.buttonPrimary,siteData.siteStyling.buttonSecondary,siteData.siteStyling.buttonTertiary]}
      labelList={["Primary","Secondary","Tertiary"]}
      componentType={wBComponentTypeNames.button}

    />


}